import { Outlet, Navigate } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';

export default function AuthLayout() {
  const { isAuthenticated, isLoading } = useAppStore();

  // Only show the spinner while auth is genuinely unresolved AND we don't
  // yet know whether the user is authenticated.
  //
  // BUG 1 fix: previously checked isLoading alone. Zustand's persist
  // middleware rehydrates isAuthenticated:true synchronously from
  // localStorage, but isLoading always booted as true (now fixed to false
  // in appStore). Without the !isAuthenticated guard, logged-in users
  // hitting any legacy /login or /register route would see a spinner for
  // the full duration of initAuth() before being redirected to /dashboard.
  if (isLoading && !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/20 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  );
}
